import { Flex } from '@chakra-ui/layout'
import { Button } from '@chakra-ui/button'

import { useGoogleMap } from '../../hooks/useGoogleMap'

import { MapIcon } from '../../assets/icons/MapIcon'
import { BulletListIcon } from '../../assets/icons/BulletListIcon'

import { ViewType } from '../../helpers/types/context/googlemap.types'

export function Footer() {
  const { viewType, setViewType } = useGoogleMap()

  return (
    <Flex
      width="100%"
      height="88px"
      position="absolute"
      bottom="0px"
      zIndex={3}
      alignItems="center"
      justifyContent="center"
      display={{
        base: 'flex',
        notebook: 'none',
      }}
      background="linear-gradient(rgba(255, 255, 255, 0), rgb(255, 255, 255))"
      onClick={() => {
        if (viewType === ViewType.MAP) {
          setViewType(ViewType.LIST)
        }

        if (viewType === ViewType.LIST) {
          setViewType(ViewType.MAP)
        }
      }}
    >
      <Button
        display="flex"
        alignItems="center"
        justifyContent="center"
        pointerEvents="none"
        borderStyle="solid"
        borderWidth="1px"
        borderColor="rgb(215, 215, 224)"
        boxSizing="border-box"
        textAlign="center"
        outline="none"
        transition="all 0.2s ease 0s"
        cursor="pointer"
        width="3rem"
        height="3rem"
        borderRadius="624.9375rem"
        fontSize="1rem"
        fontWeight="700"
        letterSpacing="normal"
        lineHeight={1}
        textDecoration="none"
        backgroundColor="rgb(255, 255, 255)"
        color="rgb(35, 27, 34)"
        padding="0px"
      >
        {viewType === ViewType.MAP && (
          <BulletListIcon
            width="24px"
            height="24px"
            transition="fill 0.2s ease 0s"
            fill="rgb(25, 27, 34)"
          />
        )}
        {viewType === ViewType.LIST && (
          <MapIcon
            width="24px"
            height="24px"
            transition="fill 0.2s ease 0s"
            fill="rgb(25, 27, 34)"
          />
        )}
      </Button>
    </Flex>
  )
}
